import CryptoJS from 'crypto-js';
import axios from 'axios';
import { makeUseAxios } from 'axios-hooks';
import { getCurrentUser } from '@aws-amplify/auth';
import { env } from '@/config';

const httpInstancePaymentLink = axios.create({
  baseURL: env.API_URL_PAYMENT_LINK,
  timeout: 30000,
});

// Add a request interceptor
httpInstancePaymentLink.interceptors.request.use(async (config) => {
  const newConfig = { ...config };
  // get authenticated user data
  const user = await getCurrentUser()
    .catch((err) => console.error(err));
  const { jwtToken } = user.signInUserSession.idToken;
  if (user) newConfig.headers.Authorization = `Bearer ${jwtToken}`;
  newConfig.headers['X-Version'] = '1.0.0';
  const demoToken = CryptoJS.HmacSHA256(JSON.stringify(newConfig.data),
    env.GW_API_REQ).toString();
  newConfig.headers['X-Signature'] = demoToken;
  newConfig.headers['x-api-key'] = env.API_KEY_PAYMENT_LINK;
  return newConfig;
}, (error) => {
  return Promise.reject(error);
});

// Add a response interceptor
httpInstancePaymentLink.interceptors.response.use((response) => {
  return response;
}, (error) => {
  return Promise.reject(error);
});

export const useAxiosInstanceMake = makeUseAxios({
  axios: httpInstancePaymentLink,
  defaultOptions: { manual: true },
});

export const useAxiosInstance = (params) => {
  const [{ data, loading, error, response }, execute] = useAxiosInstanceMake(
    typeof params === 'string' ? params : { ...params }
  );

  return [{ data, loading, error, response }, execute];
};

export default httpInstancePaymentLink;
